module.exports = __webpack_public_path__ + "img/gartek-portfolio-due-diligence-studies.e9bc2bed.jpeg";